/* eslint-disable no-unused-vars */
/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import { motion } from 'framer-motion';
import {
	Filter, Info, ChevronDown, Trash, ExternalLink, CheckCircle, GitCompareArrows
} from 'lucide-react';
import { Skeleton } from '@mui/material';
import React, {
	useCallback, useMemo, useState
} from 'react';
import moment from 'moment';
import { useShallow } from 'zustand/react/shallow';
import { connect, useDispatch } from 'react-redux';
import MetricCard from './MetricsCard';
import { Button } from '@/Components/ui/button';
import { LineChart } from '@/Components/Analytics';
import { modalActions } from '@/Actions';
import InfoModal from './infoModal';
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/Components/ui/popover';
import { cn } from '@/lib/utils';
import { useQualityAnalysisStore } from '../QualityAnalysisStore';
import {
	tabVariants, fadeVariants, timeFrameList
} from '../tempData';
import ParameterSelector from '../ParameterSelector';
import {
	cardLegendLabelGenerator,
	handleAddTimeFrame,
} from '../Services/filterDeserializer';
import CustomInputSelector from '@/Components/CustomInputSelector/CustomInputSelector';
import drawerActions from '@/Actions/drawer.actions';
import ImagesFinder from '@/Components/ImagesFinder/ImagesFinder';
import { filtersInfoChip } from '@/Helpers';
import { dateRangeHasToday } from '../DateRangeSelector/DateRangeSelector';

// Date Picker Popover Component
const DatePickerPopover = ({ item, onDateChange }) => {
	const [isOpen, setIsOpen] = useState(false);
	const handleChange = (value) => {
		setIsOpen(false);
		onDateChange(item.id, value);
	};

	return (
		<Popover open={isOpen} onOpenChange={setIsOpen}>
			<PopoverTrigger asChild>
				<span className='bg-slate-300 text-[13px] text-cyan-900 px-2 py-1 rounded cursor-pointer'>
					{item?.timeFrame?.timeType === 'daily' ||
						item?.timeFrame?.timeType === 'yearly'
						? moment(item?.timeFrame?.value).format('MMM D YYYY')
						: Array.isArray(item?.timeFrame?.value)
							? `${moment(item?.timeFrame?.value[0]).format(
								'MMM D YYYY'
							)} - ${moment(item?.timeFrame?.value[1]).format(
								'MMM D YYYY'
							)}`
							: `${moment(item?.timeFrame?.value?.startDate).format(
								'MMM D YYYY'
							)} - ${moment(item?.timeFrame?.value?.endDate).format(
								'MMM D YYYY'
							)}`}
				</span>
			</PopoverTrigger>
			<PopoverContent
				className='w-auto p-0'
				align='start'
				side='bottom'
				sideOffset={5}
			>
				{React.cloneElement(item?.timeFrame?.component, {
					onChange: handleChange,
					value: item?.timeFrame?.value,
				})}
			</PopoverContent>
		</Popover>
	);
};

const filtersInfo = {
	header: {
		date: false,
		store: false,
	},
	store: {
		text: 'Store List',
		show: true,
		permittedStore: true,
	},
	dateRangeOnly: {
		hideChip: true,
		show: true,
		text: 'Select Date Range (Applicable only to export)',
	},
	// filterMultiStore: {
	// 	show: true,
	// 	text: 'Store',
	// },
};

const exportInfo = {
	showExportBtn: true,
};

function StatisticalChart({ toggleInfoModal }) {
	const {
		cardData,
		setCardData,
		qualityParameterProducts,
		lineData,
		selectedQualityParameterProduct,
		setSelectedQualityParameterProduct,
		metricData,
		timeFrame,
		setTimeFrame,
		selectedQualityAnalysisParameter,
		collapsedCards,
		setCollapsedCards,
		statisticalLoading,
		statsBoxData,
		globalProductList,
		setSearchQuery,
		searchQuery,
		dateRangeExport,
		setDateRangeExport,
		imagesFinderFilters,
		setImagesFinderFilters,
		setTriggerExportApiCall,
		applyImagesFinderFilters,
		extraButtonInfo,
		setExtraButtonInfo,
	} = useQualityAnalysisStore(
		useShallow((state) => ({
			cardData: state.cardData,
			setCardData: state.setCardData,
			lineData: state.statisticalAnalysisData?.lineData,
			metricData: state.statisticalAnalysisData?.metricData,
			statsBoxData: state.statisticalAnalysisData?.statsBoxData,
			statisticalLoading: state.statisticalLoading,
			timeFrame: state.timeFrame,
			searchQuery: state.searchQuery,
			setSearchQuery: state.setSearchQuery,
			globalProductList: state.globalProductList,
			qualityParameterProducts: state.qualityParameterProducts,
			parameters: state.qualityAnalysisParameters,
			setTimeFrame: state.setTimeFrame,
			collapsedCards: state.collapsedCards,
			selectedQualityAnalysisParameter:
				state.selectedQualityAnalysisParameter,
			setCollapsedCards: state.setCollapsedCards,
			selectedQualityParameterProduct:
				state.selectedQualityParameterProduct,
			setSelectedQualityParameterProduct:
				state.setSelectedQualityParameterProduct,
			dateRangeExport: state.dateRangeExport,
			setDateRangeExport: state.setDateRangeExport,
			imagesFinderFilters: state.imagesFinderFilters,
			setImagesFinderFilters: state.setImagesFinderFilters,
			applyImagesFinderFilters: state.applyImagesFinderFilters,
			setTriggerExportApiCall: state.setTriggerExportApiCall,
			extraButtonInfo: state.extraButtonInfo,
			setExtraButtonInfo: state.setExtraButtonInfo,
		}))
	);

	const dispatch = useDispatch();

	// Create base product lists once based on parameter type
	// Memoize temperature products list
	const temperatureProducts = useMemo(() => {
		return globalProductList?.map?.((product) => ({
			id: product.id,
			productName: product.productName,
			title: product.productName,
			imageUrl: product.productImageUrl,
		}));
	}, [globalProductList]);

	// Memoize weight products list
	const weightProducts = useMemo(() => {
		const weightList = [];
		globalProductList?.forEach((product) => {
			product.variants
				?.filter((variant) => variant.isDisabled === false)
				.forEach((variant) => {
					weightList.push({
						id: `${product.id}-${variant.id}`,
						productName: `${product.productName} (${variant.displayName})`,
						title: `${product.productName} (${variant.displayName})`,
						imageUrl: product.productImageUrl,
					});
				});
		});
		return weightList;
	}, [globalProductList]);

	// Memoize other products list
	const otherProducts = useMemo(() => {
		return globalProductList
			?.filter((item) => qualityParameterProducts?.includes?.(item.id))
			.map((product) => ({
				id: product.id,
				productName: product.productName,
				title: product.productName,
				imageUrl: product.productImageUrl,
			}));
	}, [globalProductList, qualityParameterProducts]);

	// Memoize combined product lists
	// Memoize base list selection based on parameter
	const selectedBaseList = useMemo(() => {
		if (selectedQualityAnalysisParameter === 'temperature') {
			return temperatureProducts;
		}
		if (selectedQualityAnalysisParameter === 'weight') {
			return weightProducts;
		}
		return otherProducts;
	}, [
		temperatureProducts,
		weightProducts,
		otherProducts,
		selectedQualityAnalysisParameter,
	]);

	// Memoize filtered products based on search query
	const filteredProducts = useMemo(() => {
		if (searchQuery) {
			return selectedBaseList?.filter((product) => product.productName
				.toLowerCase()
				.includes(searchQuery.toLowerCase()));
		}
		return selectedBaseList;
	}, [selectedBaseList, searchQuery]);

	const handleDateChange = useCallback(
		(id, value) => {
			const updatedCardData = cardData.map((item) => {
				if (item.id === id) {
					return {
						...item,
						timeFrame: {
							...item.timeFrame,
							value,
						},
					};
				}
				return item;
			});
			setCardData(updatedCardData, true);
		},
		[cardData, setCardData]
	);

	const removeSelectedProduct = useCallback(
		(id) => {
			const updatedCardData = cardData?.filter((item) => item.id !== id);
			setCardData(updatedCardData, true);
		},
		[cardData, setCardData]
	);

	const statisticalGraphData = useMemo(() => {
		return {
			labels: lineData?.x ?? [],
			datasets: Object.keys(lineData?.y ?? {}).reduce((acc, key) => {
				const data = lineData?.y?.[key] ?? [];
				const card = cardData.find(
					(cardTemp) => Number(cardTemp.id) === Number(key)
				);
				// const product = globalProductList.find(
				// 	(item) => item?.id === selectedQualityParameterProduct
				// )?.productName;
				acc.push({
					label: cardLegendLabelGenerator(card),
					data,
					fill: true,
					borderColor: card?.borderColor || '#36A2EB',
					backgroundColor: card?.borderColor
						? `${card.borderColor}50`
						: 'rgba(54, 162, 235, 0.2)',
					tension: 0.1,
					key,
				});
				return acc;
			}, []),
		};
	}, [lineData]);

	const statisticalGraphAnnotations = useMemo(() => {
		// const datasetLength = statisticalGraphData?.datasets?.length;
		let data = {};
		// for (let i = 0; i < datasetLength; i++) {
		const key = statisticalGraphData?.datasets?.[0]?.key;
		const productMetrics = metricData?.[key] ?? {};
		const newData = {
			[`${0}l`]: {
				type: 'line',
				value: productMetrics?.lowerLimit ?? 0,
				endValue: productMetrics?.lowerLimit ?? 0,
				scaleID: 'x',
				borderColor: 'green',
				borderWidth: 4,
				label: {
					position: 'start',
					content: `LSL: ${productMetrics?.lowerLimit ?? ''}`,
					display: true,
				},
			},
			[`${0}u`]: {
				type: 'line',
				value: productMetrics?.upperLimit ?? 0,
				endValue: productMetrics?.upperLimit ?? 0,
				scaleID: 'x',
				borderColor: 'green',
				borderWidth: 4,
				label: {
					position: 'start',
					content: `USL: ${productMetrics?.upperLimit ?? ''}`,
					display: true,
				},
			},
		};
		data = {
			...data,
			...newData,
		};
		// }
		return data;
	}, [statisticalGraphData, metricData]);

	// Handler for product selection
	const handleProductSelection = (product) => {
		setSelectedQualityParameterProduct(product?.id);
		setExtraButtonInfo(null);
	};

	// Handler for filter updates from ImagesFinder (onUpdate prop)
	const handleFilterUpdate = (filters) => {
		setImagesFinderFilters(filters);
	};

	// Handler for when Apply button is clicked in ImagesFinder (onSubmit prop)
	const handleApplyFilters = (filters) => {
		// Update filters in store
		setImagesFinderFilters(filters);

		// Set date range for export
		setDateRangeExport({
			date: {
				from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
				to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
			},
		});

		// Trigger API call by toggling the state (like export button pattern)
		applyImagesFinderFilters();
	};

	return (
		<motion.div
			key='statistical'
			initial='enter'
			animate='center'
			exit='exit'
			variants={tabVariants}
			transition={{
				duration: 0.4,
				ease: [0.43, 0.13, 0.23, 0.96],
			}}
			className='flex-1 overflow-hidden'
		>
			<InfoModal />
			<ImagesFinder
				// hideFinder
				avoidInitialCall
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
				onSubmit={handleApplyFilters}
				onUpdate={handleFilterUpdate}
			/>
			<div className='h-full grid grid-cols-2 lg:grid-cols-12 gap-1'>
				{/* Left Sidebar with animation - FIXED WITH SCROLLABLE AREA */}
				<motion.div
					initial='hidden'
					animate='visible'
					variants={fadeVariants}
					transition={{
						delay: 0.1,
						duration: 0.5,
						ease: 'easeInOut',
					}}
					className='lg:col-span-3   bg-slate-50 rounded-lg p-2 px-4 flex flex-col overflow-hidden'
				>
					{/* Non-scrollable header section */}
					<div className='mb-1.5'>
						<div className='flex flex-col gap-0.5'>
							<div className='text-gray-400 font-bold text-[8.5px]'>
								Select Failure Parameter
							</div>
							<ParameterSelector />
						</div>
					</div>

					{/* Non-scrollable selection section */}
					<div className='flex-none '>
						<div className='flex flex-col gap-0.5 mb-2'>
							<span className='text-[8.5px] text-gray-400 font-bold'>
								Products
							</span>
							<CustomInputSelector
								inputLists={filteredProducts}
								placeholder='Select product'
								tiny
								classname='rounded-xxl border border-blue-400'
								handleSelection={(product) => handleProductSelection(product)}
								selectedValue={
									selectedQualityParameterProduct
										? filteredProducts.find(
											(p) => p.id ===
												selectedQualityParameterProduct
										)?.title
										: null
								}
								handleRemove={() => {
									setSearchQuery('');
									handleProductSelection({});
								}}
								width='100%'
								showImage
								hideAddNew
							/>
						</div>
						<div className='flex items-center justify-between gap-0.5'>
							<div className='flex py-3 flex-col relative gap-0.5'>
								<span className='text-[8.5px] absolute top-0 left-0 text-gray-400 font-bold'>
									Time Frame
								</span>
								<div className='grid grid-cols-4  w-full'>
									{timeFrameList.map((item, index) => (
										<Button
											key={index}
											onClick={() => setTimeFrame(item)}
											className={`px-1 border border-blue-600 rounded-none first:rounded-l-md last:rounded-r-md py-1 bg-white text-black hover:bg-slate-800 hover:text-white transition-colors text-[8.5px] text-center ${timeFrame === item
												? 'bg-slate-800 text-white'
												: ''
												}`}
										>
											{item}
										</Button>
									))}
								</div>
							</div>
							<div className=''>
								<div
									className='text-[10px] cursor-pointer p-0.5 px-2 tracking-wider font-bold  text-center h-full rounded-md bg-yellow-500 text-slate-700 hover:bg-yellow-600'
									disabled={cardData.length === 4}
									onClick={() => handleAddTimeFrame(selectedBaseList)}
								>
									Add Time
									{' '}
									<br />
									{' '}
									Frame
								</div>
							</div>
						</div>
					</div>

					{/* Info note about date ranges if there are any non-user-selected cards */}
					{cardData.some((item) => item.userSelected) && cardData.some((item) => !item.userSelected) && (
						<div className='bg-amber-50 border border-amber-300 rounded-lg p-2  shadow-sm'>
							<div className='flex items-start gap-1 mb-px'>
								<Info className='w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5' />
								<p className='text-[11px] text-amber-800 font-medium'>
									Additional date ranges are shown for comparison purposes.
								</p>
							</div>
							<div className='flex items-center gap-2 pt-1 border-t border-amber-200'>
								<div className='flex items-center gap-1.5'>
									<CheckCircle className='w-3.5 h-3.5 text-green-500' />
									<span className='text-[9px] text-gray-600'>Your selection</span>
								</div>
								<div className='flex items-center gap-1.5'>
									<GitCompareArrows className='w-3.5 h-3.5 text-gray-400' />
									<span className='text-[9px] text-gray-600'>Auto-added for comparison</span>
								</div>
							</div>
						</div>
					)}

					{/* Scrollable cards section */}
					<div className='flex-1 pt-1 overflow-y-auto pr-1'>
						<div className='flex flex-col gap-2'>
							{cardData.map((item, index) => {
								return (
									<div
										key={index}
										className={`border-l-4 rounded-md shadow-sm overflow-hidden relative ${item.userSelected
											? 'bg-green-50 ring-2 ring-green-400'
											: 'bg-slate-200'
											}`}
										style={{
											borderLeftColor: item.borderColor,
										}}
									>
										<div className='p-2 relative border-b flex justify-between items-center'>
											<div className='absolute -ml-1 mt-3 bg-white rounded-md'>
												{item.userSelected && (
													<div className='absolute top-1 left-1 z-10'>
														<CheckCircle className='w-4 h-4 rounded-full p-px bg-white text-green-500' />
													</div>
												)}
												{!item.userSelected && cardData.some((c) => c.userSelected) && (
													<div className='absolute top-1 left-1 z-10'>
														<GitCompareArrows className='w-4 h-4 rounded-full p-px bg-white text-gray-400' />
													</div>
												)}
											</div>
											{/* <span className='text-slate-600 font-medium text-[12px]'>
												{item.name}
											</span> */}
											<DatePickerPopover
												item={item}
												onDateChange={
													handleDateChange
												}
											/>
											<div className='flex items-center gap-3'>
												<Trash
													onClick={() => removeSelectedProduct(
														item.id
													)}
													className='w-4 h-4 text-slate-600 cursor-pointer'
												/>
												<ChevronDown
													onClick={() => {
														if (
															collapsedCards &&
															collapsedCards.includes(
																item.id
															)
														) {
															setCollapsedCards(
																collapsedCards?.filter(
																	(id) => id !==
																		item.id
																)
															);
														} else {
															setCollapsedCards(
																collapsedCards
																	? [
																		...collapsedCards,
																		item.id,
																	]
																	: [item.id]
															);
														}
													}}
													className={`w-4 h-4 text-slate-600 cursor-pointer transform transition-transform duration-300 ease-in-out ${collapsedCards &&
														collapsedCards.includes(
															item.id
														)
														? 'rotate-180 translate-y-1 '
														: ''
														}`}
												/>
											</div>
										</div>
										{
											dateRangeHasToday(item) && (
												<div className='text-[8px] text-red-600 text-center font-medium'>
													Analytics are aggregated at the end of each day, so current-day data is not available yet.
												</div>
											)
										}
										<div className='p-2 flex items-center gap-4'>
											{statisticalLoading ? (
												<Skeleton
													animation='wave'
													className='flex-1 h-[50px] border border-white-300 rounded-lg bg-white'
												/>
											) : (
												<div className='flex-1 bg-white rounded-md shadow-sm p-2'>
													<div className='flex justify-between items-center'>
														<span className='text-xs text-slate-600'>
															CP
														</span>
														<span className='text-green-600 font-bold text-[12px]'>
															{item.cp}
														</span>
													</div>
												</div>
											)}

											{statisticalLoading ? (
												<Skeleton
													animation='wave'
													className='flex-1 h-[50px] border border-white-300 rounded-lg bg-white'
												/>
											) : (
												<div className='flex-1 bg-white rounded-md shadow-sm p-2'>
													<div className='flex justify-between items-center'>
														<span className='text-xs text-slate-600'>
															CPK
														</span>
														<span className='text-red-500 font-bold text-[12px]'>
															{item.cpk}
														</span>
													</div>
												</div>
											)}
										</div>
										<div
											className={cn(
												'transition-all duration-300 ease-in-out overflow-hidden',
												collapsedCards &&
													collapsedCards.includes(
														item.id
													)
													? 'max-h-[500px] opacity-100'
													: 'max-h-0 opacity-0'
											)}
										>
											<div className='p-2 grid grid-cols-2 gap-y-2 gap-x-2'>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>
														Total
													</span>
													<span className='text-sm text-slate-600 font-semibold'>
														{item.total}
													</span>
												</div>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>
														Pass %
													</span>
													<span className='text-sm text-slate-600 font-semibold'>
														{item.passPercent}
														%
													</span>
												</div>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>
														LSL
													</span>
													<span className='text-sm text-slate-600 font-semibold'>
														{item.lsl}
													</span>
												</div>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>
														Mean
													</span>
													<span className='text-sm text-slate-600 font-semibold'>
														{item.mean}
													</span>
												</div>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>
														USL
													</span>
													<span className='text-sm text-slate-600 font-semibold'>
														{item.usl}
													</span>
												</div>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>
														Standard Deviation (σ)
													</span>
													<span className='text-sm text-slate-600 font-semibold'>
														{item.standardDeviation}
													</span>
												</div>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>Under Weight</span>
													<span className='text-sm text-slate-600 font-semibold'>{item.underWeight}</span>
												</div>
												<div className='flex justify-between items-center gap-2 bg-slate-100 rounded-md p-2'>
													<span className='text-xs text-slate-600 '>Over Weight</span>
													<span className='text-sm text-slate-600 font-semibold'>{item.overWeight}</span>
												</div>
											</div>
										</div>
										{/* <div className='p-2 '>
											<div
												className='flex items-center justify-between mb-2 pt-2'
												style={{
													borderTop:
														'1px solid rgba(0, 0, 0, 0.15)',
												}}
											>
												<span className='text-[12px] text-slate-600'>
													Time frame
												</span>
												<DatePickerPopover
													item={item}
													onDateChange={
														handleDateChange
													}
												/>
											</div>
										</div> */}
									</div>
								);
							})}
						</div>
					</div>
				</motion.div>

				{/* Main Content with animation */}
				<motion.div
					initial='hidden'
					animate='visible'
					variants={fadeVariants}
					transition={{
						delay: 0.2,
						duration: 0.5,
						ease: 'easeInOut',
					}}
					className='lg:col-span-9 flex flex-col'
				>
					<div className='flex justify-end items-end p-2 bg-white  rounded-lg mb-4'>
						{/* <div className='flex items-center gap-2 ml-5'>
							<span className='text-sm font-medium'>
								Select Parameter
							</span>
							<div className='relative w-[300px]'>
								<ParameterSelector />
							</div>
						</div> */}
						<div className='flex flex-col items-end gap-2'>
							<div className='flex gap-2 '>
								{extraButtonInfo && (
									<Button
										variant='outline'
										className='flex items-center gap-2 bg-amber-50 border-amber-400 hover:bg-amber-100'
										onClick={() => {
											window.open(extraButtonInfo.link, '_blank');
										}}
									>
										<ExternalLink className='h-4 w-4' />
										{extraButtonInfo.buttonName}
										<span className='w-1.5 h-1.5 bg-amber-600 animate-ping rounded-full' />
									</Button>
								)}
								<Button
									variant='outline'
									className='flex items-center gap-2'
									onClick={() => {
										toggleInfoModal(true);
									}}
								>
									<Info className='h-4 w-4' />
									Info
								</Button>
								<Button
									variant='outline'
									onClick={() => {
										dispatch(drawerActions.toggleFiltersDrawer(true, {
											handleDataExport: (filters) => {
												setDateRangeExport({
													date: {
														from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
														to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
													},
												});
												setTriggerExportApiCall();
											},
										}));
									}}
									className='flex items-center gap-2 bg-[#0D9488] text-white hover:bg-[#0B7C73]'
								>
									<Filter className='h-4 w-4' />
									<span>Filter</span>
								</Button>
							</div>
							<div className='flex items-center '>
								{/* Filter Chips Display */}
								{filtersInfoChip(filtersInfo, imagesFinderFilters)}
							</div>
						</div>
					</div>

					<div className='flex-1 overflow-auto'>
						<div
							className={cn(
								'grid gap-4 mb-4',
								statsBoxData?.length === 1
									? 'grid-cols-1'
									: statsBoxData?.length === 2
										? 'grid-cols-2'
										: statsBoxData?.length === 3
											? 'grid-cols-3'
											: statsBoxData?.length === 4
												? 'grid-cols-4'
												: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
							)}
						>
							{(statsBoxData || []).map((key) => (
								<MetricCard
									key={key?.label || Math.random()}
									data={key}
									tabType='stats'
								/>
							))}
						</div>
						<div className='h-[calc(100vh-22rem)] w-full'>
							<LineChart
								data={statisticalGraphData}
								annotations={statisticalGraphAnnotations}
								legendDisplay
								xScale={{
									type: 'linear',
								}}
							/>
						</div>
					</div>
				</motion.div>
			</div>
		</motion.div>
	);
}

const mapStateToProps = (state) => {
	const { show, data } = state.modal.infoModal;

	return {
		show,
		data,
	};
};

const mapDispatchToProps = {
	toggleInfoModal: modalActions.toggleInfoModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticalChart);
